import { render, staticRenderFns } from "./addSale.vue?vue&type=template&id=f272dfc6&scoped=true"
import script from "./addSale.vue?vue&type=script&lang=js"
export * from "./addSale.vue?vue&type=script&lang=js"
import style0 from "./addSale.vue?vue&type=style&index=0&id=f272dfc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f272dfc6",
  null
  
)

export default component.exports